var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "CruiseHeadLayout" },
    [
      _c("div", { staticClass: "boat" }, [
        _c(
          "div",
          {
            staticClass: "boat__info boat-info",
            class: { hide: _setup.hideInfo },
          },
          [
            _c(_setup.MySlider, {
              staticClass: "boat-info__slider",
              attrs: {
                slideRatio: 190 / 280,
                slides: _setup.headPhotos,
                srcKey: "src_next",
                idKey: "id",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "boat-info__id" }, [
              _vm._v(_vm._s(_setup.cruiseIdString)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "boat-info__title" }, [
              _vm._v(_vm._s(_setup.beautifulName)),
            ]),
            _vm._v(" "),
            _c(_setup.CruiseDates, { attrs: { dates: _setup.dates } }),
            _vm._v(" "),
            _c(_setup.ShipHead, { attrs: { ship: _setup.shipHead } }),
            _vm._v(" "),
            _setup.props.slotInfoLinkRooms
              ? [
                  _c(
                    "div",
                    { staticClass: "boat-info__price-min" },
                    [
                      _setup.min_price.is
                        ? [
                            _vm._v("от "),
                            _c(_setup.PriceCurrencyV, {
                              attrs: { price: _setup.min_price, sum: true },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "btn btn--bluefigma",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _setup.click_scrollTo("Cabins")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Выбрать каюту\n                "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "boat__content",
            class: { short: _setup.props.short, wide: _setup.hideInfo },
          },
          [
            _c(
              "div",
              { staticClass: "boat__slider slider" },
              [
                _c(_setup.MySlider, {
                  staticClass: "cruise-info__slider",
                  attrs: {
                    slideRatio: 1 / 2,
                    slides: _setup.headPhotos,
                    srcKey: "src_next",
                    idKey: "id",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("boat", null, { hideInfoGrid: _setup.hideInfoGrid }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm._t("after"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }